import SmartSalesOutputCardView from './SmartSalesOutputCardView.html';
import { SmartSalesConstants } from '../../../../smartSales/SmartSalesConstants';
class SmartSalesOutputCard {
    static $inject = ['$translate'];
    constructor($translate) {
        'ngInject';
        this.$translate = $translate;
        this.availableStatus = [
            {
                value: SmartSalesConstants.USER_RESPONSE_STATUS.ACCEPT_TO_BUY,
                label: this.$translate.instant('builder-tabs-outputs.smartSales.acceptOrder'),
            },
            {
                value: SmartSalesConstants.USER_RESPONSE_STATUS.REFUSED_TO_BUY,
                label: this.$translate.instant('builder-tabs-outputs.smartSales.declineOrder'),
            },
            {
                value: SmartSalesConstants.USER_RESPONSE_STATUS.INACTIVITY,
                label: this.$translate.instant('builder-tabs-outputs.smartSales.inactivity'),
            },
        ];
    }
    $onInit() {
        this.condition = this.output.conditions[0];
        const status = this.condition.values[0];
        this.selectedStatus = this.availableStatus.find(s => s.value == status);
    }
    addNewState($data) {
        $data.output = this.output;
        $data.state = this.state;
        this.onAddNewState({ $data });
    }
    changeOutputState($data) {
        $data.output = this.output;
        this.outputChanged({ $data });
    }
    toggleInfo() {
        this.showInfo = !this.showInfo;
    }
}
SmartSalesOutputCard.$inject = ['$translate'];
export const SmartSalesOutputCardComponent = {
    controller: SmartSalesOutputCard,
    controllerAs: '$ctrl',
    template: SmartSalesOutputCardView,
    bindings: {
        output: '<',
        outputChanged: '&',
        states: '<',
        state: '<',
        onRemove: '&',
        onAddNewState: '&?',
    },
};
